<app-widget [widget-meta]="this.data" class="widget-my-degree" showHelp="true">
  @if (degreeAudit.degreeDetail$ | async; as degree) {
    @if (!!degree.DegreeName) {
      <div class="mb-2">
        <div class="row">
          <div class="col-md-10">
            <small>
              Currently Selected Degree: {{degree.DegreeName}}
              @if (!profileService.isUpdating.includes('conc')) {
                @if ((profileService.viewConcentrations$| async); as concData) {
                  @for (conc of (profileService.viewConcentrations$| async).concentrations; track $index; let first = $first; let last = $last) {
                    {{(first ? 'with ' + (last ? 'a ' + conc.Type + ' ' : conc.Type + 's ') + 'in ' : ' and ')|lowercase}}
                    @if (!concData.userMayEditConcentration) {
                      <span>{{conc.Value ? conc.Value : 'None'}}</span>
                    } @else {
                      <button type="button" class="btn btn-sm btn-link btn-inline" (click)="openConc(concData.concentrations)">{{conc.Value ? conc.Value : 'None'}}</button>
                      }{{last? '.' : ''}}
                    }
                  }
                } @else {
                  <i class="fas fa-circle-notch fa-spin"></i>
                }
                <button class="btn bt-sm btn-link btn-inline btn-degree-download-text" (click)="degreeAudit.openPdf()" [disabled]="degreeAudit.isLoadingPdf">
                  (Download Unofficial Report)
                  @if (degreeAudit.isLoadingPdf) {
                    <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                  }
                </button>
              </small>
            </div>
            <div class="col-md-2">
              <button class="btn bt-sm btn-link btn-degree-download-icon" (click)="degreeAudit.openPdf()" [disabled]="degreeAudit.isLoadingPdf">
                <i class="fas fa-download"></i><span class="sr-only">Download Unofficial Report</span>
              </button>
            </div>
          </div>
        </div>
      }
      @if (!degree.DegreeName && !degree.IsManualAudit) {
        <div>No audit information available.</div>
      }
      @if (!degree.DegreeName && degree.IsManualAudit) {
        <div>Please see your program's helpdesk, your audit must be performed manually.</div>
      }
      @if (!!degree.DegreeName && !degree.IsManualAudit) {
        <div class="card-expansion" id="accordion">
          <div class="card card-expansion-item mb-3">
            <button [attr.aria-controls]="'collapseDegree'" aria-expanded="false"
              class="btn collapsed" [attr.data-bs-target]="'#collapseDegree'"
              data-bs-toggle="collapse">
              <div class="container-fluid px-0">
                <div class="row">
                  <div class="col-md-4 col-sm-4 text-start">
                    <strong>
                      <span class="collapse-indicator"><i class="fas fa-plus-circle"></i></span> &nbsp;
                      {{degree.DegreeName}} Degree
                    </strong>
                  </div>
                  <div class="col-md-8 col-sm-8">
                    <my-degree-simple-progress-bar [complete]="degree.PercentageComplete"></my-degree-simple-progress-bar>
                  </div>
                </div>
              </div>
            </button>
            <div [id]="'collapseDegree'" class="collapse" data-bs-parent="#accordion">
              <div class="card mb-3 pb-2">
                <div class="container pt-3">
                  @for (degreeDetail of degree.DegreeDetail; track degreeDetail) {
                    <div>
                      <div>
                        <span class="fw-bold">{{degreeDetail.Title}} Classes</span> -
                        <span class="small">{{degreeDetail.Description}}</span>
                      </div>
                      <my-degree-detail-progress-bar [complete]="degreeDetail.PercentageComplete"
                        [inProgress]="degreeDetail.PercentageInProgress"
                      [remaining]="degreeDetail.PercentageRemaining"></my-degree-detail-progress-bar>
                      @if ((degree.DegreeName == 'MAC') || (degree.DegreeName == 'MAC Online')) {
                        @if (degreeDetail.RecommendedClasses?.length) {
                          <div>
                            <span class="fw-bold">Credit required from at least one of the below courses:</span>
                            <ul>
                              @for (degreeAuditCourse of degreeDetail.RecommendedClasses; track degreeAuditCourse) {
                                <li class="">
                                  <a class="small" [routerLink]="['/catalog']"
                                    [queryParams]="{program: degreeAuditCourse.Subject.trim(), classNum: degreeAuditCourse.CourseNumber, academicYear: degreeAuditCourse.AcademicYear}">
                                    {{degreeAuditCourse.CourseTitle}}
                                  </a>
                                </li>
                              }
                            </ul>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (degreeAudit.top3OptionalByType$ | async; as topConcs;) {
        <div>
          @if (degreeAudit.optionalByType$ | async; as allConcs;) {
            <div>
              @if (degreeAudit.selectedByType$ | async; as selectedConcs;) {
                <div>
                  @if (profileService.viewConcentrations$ | async; as concData) {
                    <div>
                      @if (allConcs.length) {
                        <div class="card-expansion">
                          <div class="card card-expansion-item mb-3">
                            @if (!showAllConcentrations) {
                              <div class="ps-2">
                                <strong>
                                  My
                                  <ng-container [ngTemplateOutlet]="groupLinks" [ngTemplateOutletContext]="{ concentrations:concData.concentrations, includesel:'' }"></ng-container>
                                </strong>
                                <button class="btn btn-link" (click)="toggleConcentrationView()">
                                  [All My
                                  <ng-container [ngTemplateOutlet]="groupLinks" [ngTemplateOutletContext]="{ concentrations:concData.concentrations, includesel:'' }"></ng-container>
                                  ]
                                </button>
                              </div>
                            }
                            @if (showAllConcentrations) {
                              <div class="ps-2">
                                <strong>
                                  All My
                                  <ng-container [ngTemplateOutlet]="groupLinks" [ngTemplateOutletContext]="{ concentrations:concData.concentrations, includesel:'' }"></ng-container>
                                </strong>
                                <button class="btn btn-link" (click)="toggleConcentrationView()">
                                  [My
                                  <ng-container [ngTemplateOutlet]="groupLinks" [ngTemplateOutletContext]="{ concentrations:concData.concentrations, includesel:'' }"></ng-container>
                                  ]
                                </button>
                              </div>
                            }
                            @if (topConcs  && !showAllConcentrations) {
                              <ng-container [ngTemplateOutlet]="concentrations"
                                [ngTemplateOutletContext]="{ concentrations:topConcs, degreeName:degree.DegreeName, showAll:showAllConcentrations, selected: selectedConcs}">
                              </ng-container>
                            }
                            @if (allConcs && showAllConcentrations) {
                              <ng-container [ngTemplateOutlet]="concentrations"
                                [ngTemplateOutletContext]="{ concentrations:allConcs, degreeName:degree.DegreeName, showAll:showAllConcentrations, selected: null }">
                              </ng-container>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!!degree.DegreeName) {
        <div class="card-expansion text-center mb-3">
          <small>Download an unofficial degree report, available above, for more information on your course progression.</small>
        </div>
      }
      @if (!!degree.DegreeName) {
        <div class="card-expansion">
          <div class="card mb-3">
            <span class="alert alert-danger text-center mb-0">This is NOT an official audit, if there are any questions about the results of this audit please contact your program's helpdesk.</span>
          </div>
        </div>
      }
    } @else {
      <div class="widget-loading text-center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    }
    <ng-template #groupLinks let-concentrations="concentrations" let-includesel="includesel">
      @if (concentrations.length) {
        <span>{{concentrations[0].Type}}s {{includesel}}</span>
      }
      @if (!concentrations.length) {
        <span>Groups</span>
      }
    </ng-template>

    <ng-template #concentrations let-concentrations="concentrations" let-degreeName="degreeName" let-showAll="showAll" let-selected="selected">
      @if (!!selected && selected[0].Concentrations && selected[0].Concentrations.length) {
        <div class="mb-2">
          <div class="containter ps-2"><strong>Currently Selected</strong></div>
          @for (conc of selected; track conc; let i = $index) {
            <div>
              <ng-container [ngTemplateOutlet]="accordion" [ngTemplateOutletContext]="{ conc:conc, i:i }"></ng-container>
            </div>
          }
        </div>
      }
      @for (conc of concentrations; track $index; let i = $index) {
        <div>
          <div class="containter ps-2"><strong>{{showAll ? '' : 'Top'}} {{conc.Type}}{{degreeName == 'MBA' ? ' & Secondary':'s'}}</strong></div>
          <ng-container [ngTemplateOutlet]="accordion" [ngTemplateOutletContext]="{ conc:conc, i:(i +'c') }"></ng-container>
        </div>
      }
    </ng-template>

    <ng-template #accordion let-conc="conc" let-i="i">
      <div id="accordion{{i}}">
        @for (concentration of conc.Concentrations; track $index; let j = $index) {
          <div>
            <div id="heading{{i}}{{j}}">
              <button [attr.aria-controls]="'collapse' + i + j" aria-expanded="false" class="btn w-100 collapsed"
                [attr.data-bs-target]="'#collapse' + i + j" data-bs-toggle="collapse">
                @for (audit of concentration.Audits | slice:0:1; track audit; let t = $index) {
                  <div>
                    <div class="row">
                      <div class="col-md-4 col-sm-4 text-start fw-bold">
                        <span class="collapse-indicator"><i class="fas fa-plus-circle"></i></span>&nbsp;
                        @if (concentration.IsMyConcentration) {
                          <span><i class="fas fa-badge-check text-success"></i></span>
                        }
                        {{audit.Title}}
                      </div>
                      <div class="col-md-8 col-sm-8">
                        <my-degree-simple-progress-bar [complete]="audit.TotalPercentageComplete"></my-degree-simple-progress-bar>
                      </div>
                    </div>
                  </div>
                }
              </button>
            </div>
            <div [attr.aria-labelledby]="'heading' + i + j" class="collapse" [attr.data-bs-parent]="'#accordion' + i" id="collapse{{i}}{{j}}" style="">
              <div class="card mb-3 pb-2">
                <div>
                  @for (audit of concentration.Audits; track audit; let t = $index) {
                    <div>
                      @if (t != 0) {
                        <hr class="degree-track-divider" />
                      }
                      @if (concentration.Audits.length > 1) {
                        <div class="container pt-2">
                          <strong>
                            {{audit.TemplateName}}
                          </strong>
                          <my-degree-simple-progress-bar [complete]="audit.TotalPercentageComplete"></my-degree-simple-progress-bar>
                        </div>
                      }
                      <div class="container pt-3">
                        @for (group of audit.Groups; track group) {
                          <div class="pb-3">
                            <div>
                              <span class="fw-bold">{{group.Title}}</span> -
                              <span class="small">{{group.Description}}</span>
                            </div>
                            <my-degree-detail-progress-bar [complete]="group.PercentageComplete"
                              [inProgress]="group.PercentageInProgress"
                            [remaining]="group.PercentageRemaining"></my-degree-detail-progress-bar>
                            @if (group.RecommendedClasses?.length) {
                              <div>
                                <span class="fw-bold">The following classes may be of interest:</span>
                                <ul>
                                  @for (degreeAuditCourse of group.RecommendedClasses; track $index) {
                                    <li class="">
                                      <a class="small" [routerLink]="['/catalog']"
                                        [queryParams]="{program: degreeAuditCourse.Subject.trim(), classNum: degreeAuditCourse.CourseNumber, academicYear: degreeAuditCourse.AcademicYear}">
                                        {{degreeAuditCourse.CourseTitle}}
                                      </a>
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </ng-template>


  </app-widget>
